(function () {
  const root = document.getElementById("xtra__scroll-newsletter");
  if (root === null) {
    return;
  }

  let dismissed = sessionStorage.getItem("xtra__scroll-newsletter-closed");

  window.addEventListener("scroll", function () {
    const h = document.body.scrollHeight - window.innerHeight;
    const scrollY = window.scrollY;

    const TRIGGER_DIST = 500;

    if (scrollY > h - TRIGGER_DIST) {
      if (!dismissed) {
        root.setAttribute("data-open", "true");
      }
    } else {
      root.removeAttribute("data-open");
    }
  });

  root.addEventListener("click", function (e) {
    if (
      e.target.getAttribute("data-action") ===
      "xtra__scroll-newsletter__dismiss"
    ) {
      root.removeAttribute("data-open");
      sessionStorage.setItem("xtra__scroll-newsletter-closed", true);
      dismissed = true;
    }
  });

  const triggerButton = document.querySelector(
    "[data-action=xtra__scroll-newsletter__trigger]",
  );
  triggerButton.addEventListener("click", function () {
    root.setAttribute("data-open", "true");
    sessionStorage.setItem("xtra__scroll-newsletter-closed", true);
  });
})();
